import ApiBase from './api-base'
import ServiceAgreementAdapter from './adapters/serviceAgreement'
import { v2m5mHeaders } from '@/modules/config/api'

class ServiceAgreement extends ApiBase {
  constructor () {
    super()
    this.adapters = {
      serviceAgreement: new ServiceAgreementAdapter()
    }
    this.url = '/v2.6/auth/service_agreements'
  }

  async fetchServiceAgreements (type = null) {
    const url = this.url
    const { data } = await this.client.get(url, {
      headers: v2m5mHeaders,
      params: { 'filter[type]': type }
    })

    return { data: this.adapters.serviceAgreement.adaptData(data.data) }
  }
}

export default ServiceAgreement
